import { Component, Signal, computed, inject, input } from '@angular/core';

import { Observable, of } from 'rxjs';

import { AspectRatioString, FinnairThemeService } from '@fcom/common';
import { FinnairTheme } from '@fcom/common/interfaces/theme.interface';
import { CmsArticle, CmsImageData, CmsTaxonomy, CmsTaxonomyGeneral, CmsTeaser } from '@fcom/core-api';

@Component({
  selector: 'cms-text-with-side-image',
  styleUrls: ['./cms-text-with-side-image.component.scss'],
  templateUrl: './cms-text-with-side-image.component.html',
  standalone: false,
})
export class CmsTextWithSideImageComponent {
  private readonly themeService = inject(FinnairThemeService);

  content = input.required<CmsArticle>();
  imageLeft = input(false);

  readonly isNewBrand: Signal<boolean> = computed((): boolean => {
    return this.themeService.siteTheme() !== FinnairTheme.LEGACY;
  });

  readonly TAXONOMY: typeof CmsTaxonomyGeneral = CmsTaxonomyGeneral;

  readonly aspectRatio$: Observable<AspectRatioString> = of('1x1' as AspectRatioString);

  readonly textContent = computed((): CmsArticle => {
    const content = this.content();
    if (!content) {
      return undefined;
    }
    const { media: _, ...rest } = content;
    return { ...rest, media: [] };
  });

  readonly image = computed((): CmsImageData => {
    return (this.content()?.media ?? [])[0] as CmsImageData;
  });

  readonly link = computed((): CmsTeaser => {
    return (this.content()?.related ?? [])[0] as CmsTeaser;
  });

  private readonly cmsTags = computed((): Array<CmsTaxonomy | string> => {
    return this.content()?.subjectTaxonomyTags ?? [];
  });

  readonly isBlackFriday = computed((): boolean => {
    return this.cmsTags().includes(this.TAXONOMY.BLACK_FRIDAY);
  });

  readonly noPadding = computed((): boolean => {
    return this.cmsTags().includes(this.TAXONOMY.NO_PADDING);
  });
}
